var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('top-bar'),_vm._v(" "),_c('side-bar',{attrs:{"disabledOptions":_vm.showNoData}}),_vm._v(" "),[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{on:{"click":_vm.toggleMenu}})],1)],_vm._v(" "),(_vm.showNoData)?_c('no-data'):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-025845e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/routes/school/School.vue
// module id = null
// module chunks = 